(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TerrainType', TerrainType);

    TerrainType.$inject = ['$resource', 'DateUtils'];

    function TerrainType ($resource, DateUtils) {
        var resourceUrl =  'api/terrain-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TerrainTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getterraintypebyname = function (data,callback){
		$http.get('api/terrain-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TerrainTypeSearch', TerrainTypeSearch);

    TerrainTypeSearch.$inject = ['$resource'];

    function TerrainTypeSearch ($resource) {
        var service = $resource('/api/terrain-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomTerrainTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-terrain-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();